import { initializeApp } from 'firebase/app';
import {
  FirebaseStorage,
  connectStorageEmulator,
  getStorage as getFirebaseStorage,
} from 'firebase/storage';
import {
  Analytics,
  getAnalytics as getFirebaseAnalytics,
} from 'firebase/analytics';
import {
  Firestore,
  connectFirestoreEmulator,
  getFirestore,
} from 'firebase/firestore';
import {
  Auth,
  connectAuthEmulator,
  getAuth as getFirebaseAuth,
} from 'firebase/auth';
import {
  connectFunctionsEmulator,
  Functions,
  getFunctions as getFirebaseFunctions,
} from 'firebase/functions';

const firebaseConfig = {
  apiKey: 'AIzaSyDbM8sSnqaDMqIubFNYHxciB_2WGS0VKQI',
  authDomain: 'foundry.kaddo.app',
  projectId: 'kaddo-f5ca8',
  storageBucket: 'kaddo-f5ca8.appspot.com',
  messagingSenderId: '1060326701755',
  appId: '1:1060326701755:web:64f2b082b8be671c9b479e',
  measurementId: 'G-DVN14PR9JJ',
};

export const firebaseInit = () => {
  const app = initializeApp(firebaseConfig);
  getFirebaseAnalytics(app);
  getFirestore(app);
};

const once = <T>(fn: () => T) => {
  let result: Record<string, T> | undefined;

  const doOnce = () => {
    if (result) {
      return result.result;
    }

    result = { result: fn() };

    return result.result;
  };

  return () => doOnce();
};

export const getDb = once<Firestore>(() => {
  const db = getFirestore();

  if (import.meta.env.MODE === 'development') {
    connectFirestoreEmulator(db, 'localhost', 8080);
  }

  return db;
});

export const getAuth: () => Auth = once<Auth>(() => {
  const auth = getFirebaseAuth();

  if (import.meta.env.MODE === 'development') {
    connectAuthEmulator(auth, 'http://localhost:9099');
  }

  return auth;
});

export const getAnalytics = once<Analytics>(() => getFirebaseAnalytics());

export const getStorage: () => FirebaseStorage = once<FirebaseStorage>(() => {
  const storage = getFirebaseStorage();

  if (import.meta.env.MODE === 'development') {
    connectStorageEmulator(storage, 'localhost', 9199);
  }

  return storage;
});

export const getFunctions: () => Functions = once<Functions>(() => {
  const functions = getFirebaseFunctions();

  if (import.meta.env.MODE === 'development') {
    connectFunctionsEmulator(functions, 'localhost', 5001);
  }

  return functions;
});
